import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqComplementos = {
	// Complementos de um produto prontos pra venda (grupos + itens já com valor/estoque/is_grade/subitem)
	listarComplementosProduto: async function (idProduto) {
		return apiServer
			.get(`portal/v1/complementoapi/itens/${idProduto}/produtos-colaborador`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listarGrupos: async function (paramName, paramValue, active) {
		return apiServer
			.get("portal/v1/complementoapi/grupos", {
				params: {
					param: paramName || "descricao",
					paramValue: paramValue || "",
					descricao: paramName === "descricao" ? paramValue || "" : paramValue || "", // Mantém compatibilidade temporária com o backend atual
					active: active,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	buscarGrupo: async function (id) {
		return apiServer
			.get(`portal/v1/complementoapi/grupo/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	buscarItem: async function (id) {
		return apiServer
			.get(`portal/v1/complementoapi/item/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	deletarItem: async function (id) {
		return apiServer
			.patch(
				`portal/v1/complementoapi/item/${id}`,
				{
					ativo: false,
				},
				{
					headers: {
						banco: banco,
					},
				},
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	ativarItem: async function (id, ativo) {
		return apiServer
			.patch(
				`portal/v1/complementoapi/item/ativo/${id}`,
				{ ativo },
				{
					headers: {
						banco: banco,
					},
				},
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listarItensGrupos: async function (idgrupos) {
		return apiServer
			.get("portal/v1/complementoapi/itensgrupos", {
				params: {
					idgrupo: idgrupos,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	inserirComplemento: async function (id_estabelecimento, data) {
		return apiServer
			.post("portal/v1/complementoapi/complemento", data, {
				headers: {
					banco: banco,
					id_estabelecimento: id_estabelecimento,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	inserirGrupos: async function (id_estabelecimento, data) {
		return apiServer
			.post("portal/v1/complementoapi/grupos", data, {
				headers: {
					banco: banco,
					id_estabelecimento: id_estabelecimento,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	inserirItens: async function (data) {
		return apiServer
			.post("portal/v1/complementoapi/itens", data, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	deletarComplemento: async function (idgrupos, id_estabelecimento) {
		return apiServer
			.delete("portal/v1/complementoapi", {
				params: {
					idgrupos: idgrupos,
					id_estabelecimento: id_estabelecimento,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listarProdutosVinculo: async function (idGrupo) {
		return apiServer
			.get(`portal/v1/complementoapi/grupo/${idGrupo}/produtos`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	syncComplementosProdutos: async function (idGrupo, arrayIds) {
		return apiServer
			.post(`portal/v1/complementoapi/grupo/${idGrupo}/produtos`, arrayIds, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqComplementos;
